import {CSSProperties, useEffect, useRef, useState} from "react";
import {useMapsLibrary} from "@vis.gl/react-google-maps";

interface PlaceAutocompleteProps {
  styles?: CSSProperties,
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
}

export const PlaceAutocomplete = (props: PlaceAutocompleteProps) => {

  const [searchBox, setSearchBox] =
      useState<google.maps.places.SearchBox | null>(null);

  const inputRef = useRef<HTMLInputElement>(null);
  const places = useMapsLibrary('places');

  useEffect(() => {
    if (!places || !inputRef.current) return;

    // Initialize SearchBox instead of Autocomplete
    setSearchBox(new places.SearchBox(inputRef.current));
  }, [places]);

  useEffect(() => {
    if (!searchBox) return;

    // SearchBox uses 'places_changed' event instead of 'place_changed'
    const listener = searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      // SearchBox returns an array of places, get the first one
      if (places && places.length > 0) {
        props.onPlaceSelect(places[0]);
      } else {
        props.onPlaceSelect(null);
      }
    });

    return () => {
      // Important to clean up this listener if the component is unmounted
      // or else the listener stays active
      listener.remove();
    }

  }, [props.onPlaceSelect, searchBox]);

  return (
      <input 
        style={{...{padding: 10, width: 250}, ...props.styles}} 
        ref={inputRef}
        placeholder="Search locations"
      />
  );
};